// import React from 'react';
// import { formatPrice, numberToWords,invoiceCalculate, formatPhoneNumber } from '../../../utils/Common';
// import Watermark from '../Watermark/Watermark';
// import './PdfHtmlContent.css';



// import QRCode from 'react-qr-code';

// const PdfHtmlContentPurCustomize = props => {

//   const { invoice, invoiceSetting, id } = props;
//   const BASE_URL = process.env.REACT_APP_ROOT_URL;
//   const invoiceDate = new Date(invoice.created_at);
//   const year = invoiceDate.getFullYear();
//   const month = String(invoiceDate.getMonth() + 1).padStart(2, '0');
//   const day = String(invoiceDate.getDate()).padStart(2, '0');
//   const hours = String(invoiceDate.getHours() % 12).padStart(2, '0');
//   const minutes = String(invoiceDate.getMinutes()).padStart(2, '0');
//   const ampm = invoiceDate.getHours() >= 12 ? 'PM' : 'AM';

//   const shop_logo = invoiceSetting?.shop_logo ? invoiceSetting?.shop_logo : `${BASE_URL}/layoutlogo.svg`;
//   const formattedDate = `${year}-${month}-${day}`;
//   const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
//   let totalQty = 0;
//   let totalItems = 0;
//   let totalPrice = 0;




//   return (
//     <div id="pdfContentAreasCustomize" className="pdfConentAreasCustomize">
//       <div id="invoice-detail-page" className="invoice-detail-page font-nunito">
//         {/* <div className="invoice-info">
//           <h1>Invoice</h1>
//           <p>{invoice.invoice_id}</p>
//           <p>{formattedDate}</p>
//         </div> */}
//         <div className="invoice-header">
//           <div className="invoice-logo font-nunito font-semibold mx-auto w-[100px]  md:w-[551px]  text-center ">

//               <img src={shop_logo} alt={invoice.invoice_id} className="mx-auto w-1/2 md-[0px] max-w-[220px]" />
//             <div className='my-2'>
//               {invoiceSetting.shop_name &&
//                 <p className='text-[20px]'>{invoiceSetting.shop_name} </p>
//               }
//               {invoiceSetting.shop_address &&
//                 <p>{invoiceSetting.shop_address}</p>
//               }
//                {invoiceSetting?.mobile_number &&
//                 <p>Mobile: {formatPhoneNumber(invoiceSetting?.mobile_number) }</p>
//               }
//                <div className='flex flex-col '>
//            <span>{invoiceSetting?.web_address ?
//               invoiceSetting?.web_address
//             : (
//               ""
//             )}</span>
//             <span>
//             {invoiceSetting?.social_link ?
//               invoiceSetting?.social_link
//             : (
//               ""
//             )}
//             </span>

//             </div>
//             </div>
//           </div>

//           {/* <div>
//             <h1 className='font-bold text-[20px] font-nunito '>{invoiceSetting.shop_name}</h1>
//             <p className="mt-1 mb-1 text-13 font-semibold text-gray-700 font-nunito">{invoiceSetting.shop_address}</p>
//             <p className="text-blue-500 font-nunito text-12 font-bold">Mobile: +880 1726594320</p>
//           </div> */}
//         </div>
//         {/* <DashedLine /> */}

//         <div className="invoice-customer flex justify-between m-3 items-center">
//           <div className="text-black font-nunito text-24 leading-140">
//             <p className='mb-2'> <span className='font-semibold'>Vendor Name</span>  :  {invoice.vendor_name} </p>
//             <p className='mb-2'><span className='font-semibold'>Vendor Phone</span> :  {invoice.country_code}{invoice.vendor_phone}</p>
//             <p className='mb-2'><span className='font-semibold'> Vendor ID </span> : {invoice.vendor_id}</p>
//             <p className='mb-2'><span className='font-semibold'> Invoice Date </span>: {formattedDateTime} </p>
//           </div>
//           <div className="w-[100px]">
//             <QRCode className="w-full object-contain" value={BASE_URL + '/purchase-invoice/' + invoice.invoice_id} size={100} />
//           </div>
//         </div>

//         <div style={{ width: '100%', backgroundColor: '#3056FA', padding: '10px', textAlign: 'center', margin: '15px auto' }}>
//           <p className="text-white font-nunito text-14 font-bold uppercase">Invoice No: {invoice.invoice_id}</p>
//         </div>

//         <div className={`invoice-items`}>
//           <table className={`table ${'h-[600px]' ? 'overflow-x-scroll' : 'overflow-x-hidden'}`}>
//             <thead>
//               <tr className="text-gray-900 font-nunito text-base font-semibold leading-normal tracking-wide relative">
//                 <th><span className="hidden md:inline-block">Item</span> Name</th>
//                 <th>Warranties</th>
//                 <th>Quantity</th>
//                 <th>Price</th>
//                 <th className='absolute right-0'>Total</th>
//               </tr>
//             </thead>
//             <tbody>
//               {invoice.purchase_details ?
//                 invoice.purchase_details.map((item) => {
//                   totalQty += Number(item.qty);
//                   totalItems += 1;
//                   const subtotalPrice = formatPrice(item.qty * item.price);
//                   totalPrice += Number(subtotalPrice);
//                   return (
//                     <tr key={item.id} className="text-blue-gray-500 font-nunito text-[15px]">
//                       <td>
//                           {`${item?.product_info?.name} ${
//                             item?.product_imei[0]?.color
//                               ? `(${item?.product_imei[0]?.color})`
//                               : ""
//                           } ${
//                             item?.product_imei[0]?.storage
//                               ? `- ${item?.product_imei[0]?.storage} GB`
//                               : ""
//                           }  ${
//                             item?.product_imei[0]?.battery_life
//                               ? `- ${item?.product_imei[0]?.battery_life} (Battery)`
//                               : ""
//                           }`}

//                           <br />
//                           <span className="text-[13px]">
//                             {item?.product_imei[0]?.imei
//                               ? item?.product_imei[0]?.imei
//                               : item?.product_info?.serial}
//                           </span>
//                         </td>
//                       <td>{item.qty}</td>
//                       <td>{item.price}</td>
//                       <td className='text-gray-900 font-nunito  font-semibold '>{subtotalPrice}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</td>
//                     </tr>
//                   );
//                 }
//                 ) : null}
//             </tbody>
//             <Watermark text={invoice?.user_info?.invoiceSetting?.watermark_text}></Watermark>
//           </table>
//         </div>
//         {/* <DashedLine2 /> */}
//         <br />
//         <div className='flex justify-between'>
//           <div className="terms-condition font-semibold text-[18px]">
//             {invoiceSetting?.purchase_condition ?
//               invoiceSetting?.purchase_condition
//               : (
//                 ""
//                 // <p>Damage caused by misuse, abuse, or neglect.<br />
//                 //   Unauthorized modifications or repairs.<br />
//                 //   Acts of nature, such as floods, earthquakes, or other disasters.<br />
//                 //   This may include proper use.</p>
//               )}
//           </div>
//           <div className="invoice-summary ">

//             <p className='flex mt-2 justify-between text-navy-800 font-nunito font-semibold gap-3'>
//               <span>TOTAL ITEMS </span>
//               <span>{totalItems}</span>
//             </p>

//             <p className='flex mt-2 justify-between text-navy-800 font-nunito font-semibold gap-3'>
//               <span>SUB TOTAL</span>
//               <span>{totalPrice}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//             <p className='flex mt-2 justify-between text-blue-gray-500 font-nunito font-semibold gap-5'>
//               <span>Discount {''}</span>
//               <span>{invoice?.discount ? (invoice?.discount) : 0}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//             <p className='flex mt-2 justify-between text-blue-gray-500 font-nunito font-semibold gap-5'>
//               <span>Vat {''}</span>
//               <span>{invoice.vat ? formatPrice(invoice.vat) : 0.00}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//             <p className='flex mt-2 justify-between text-blue-gray-500 font-nunito font-semibold gap-5'>
//               <span>Service Charge {''}</span>
//               <span>{invoice.tax ? formatPrice(invoice.tax) : 0.00}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//             <hr></hr>
//             <p className='flex mt-2 justify-between text-navy-800 font-nunito font-semibold gap-3'>
//               <span>Grand Total</span>
//               <span>{formatPrice(invoiceCalculate(invoice,'purchase').grandTotal)}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//             <p className='flex mt-2 justify-between text-navy-800 font-nunito font-semibold gap-3'>
//               <span>Paid Amount</span>
//               <span>{invoice.paid_amount && invoice.paid_amount!='' ? formatPrice(invoice.paid_amount): formatPrice(0)}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//             <hr></hr>
//             <p className='flex mt-2 justify-between text-navy-800 font-nunito font-semibold gap-3'>
//               <span>Due Amount</span>
//               <span> { formatPrice(invoiceCalculate(invoice,'purchase').dueAmount) }{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'}</span>
//             </p>
//           </div>
//         </div>
//         <p className='text-gray-900 mt-3 font-nunito text-[18px] font-semibold leading-normal text-center'>In Word: {numberToWords(formatPrice(invoiceCalculate(invoice,'purchase').grandTotal))} taka only</p>
//         <div style={{ width: '100%', backgroundColor: '#034AFF', padding: '10px', textAlign: 'center', margin: '25px auto' }}>
//           <p className="text-white font-nunito text-14 font-bold">You saved {formatPrice(invoice.discount ? invoice.discount : 0)}{invoice?.user_info?.invoiceSetting?.currency_info?.code ? invoice?.user_info?.invoiceSetting?.currency_info?.code : ' BDT'} in this purchase </p>
//         </div>
//         <div>
//           <div className='flex justify-between'>
//             <p className="invisible">.</p>
//             {!id && invoiceSetting?.sign_authority ? <div className='w-[120px] h-[120px] rounded-lg'>
//               <img src={invoiceSetting.sign_authority} className='object-cover' />
//             </div> : null }
//           </div>
//           <div className="flex justify-between m-2">
//             <p ><hr></hr> Vendor Signature</p>
//             <p ><hr></hr> Customer Signature </p>
//           </div>
//         </div>

//       </div>
//       <div className='text-center font-nunito'>

//         <h2 className='text-orange-500  text-xl font-semibold '>Thanks for purchase</h2>
//         <p className='text-black mt-3 text-xs mb-2'>A Product of SQUAD INNOVATORS </p>
//       </div>

//     </div>

//   );
// };

// export default PdfHtmlContentPurCustomize;


import { numberToWords, formatPrice, invoiceCalculate } from "../../../utils/Common"
import QRCode from "react-qr-code"
import Watermark from '../Watermark/Watermark';
import './PdfHtmlContent.css';

const PdfHtmlContentPurCustomize = ({ invoice, invoiceSetting, id, BASE_URL }) => {
  const invoiceDate = new Date(invoice.created_at)
  const year = invoiceDate.getFullYear()
  const month = String(invoiceDate.getMonth() + 1).padStart(2, "0")
  const day = String(invoiceDate.getDate()).padStart(2, "0")
  const hours = String(invoiceDate.getHours() % 12).padStart(2, "0")
  const minutes = String(invoiceDate.getMinutes()).padStart(2, "0")
  const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM"
  const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`

  let totalQty = 0
  let totalItems = 0
  let totalPrice = 0
  let totalPricePrintCustomize = 0
  let totalItemsPrintCustomize = 0

  // Calculate grand total
  const grandTotal = Number.parseFloat(
    (Number(totalPrice) + Number(invoice?.vat || 0) + Number(invoice?.tax || 0)).toFixed(2),
  )
  const paidAmount = Number(invoice.paid_amount && invoice.paid_amount !== 0 ? invoice.paid_amount : 0)
  const dueAmount = grandTotal - paidAmount

  const isFullyPaid = dueAmount === 0
  const isFullyDue = paidAmount === 0
  const isPartiallyPaid = paidAmount > 0

  return (
    <div className="hidden">
      <div id="pdfContentAreasCustomize" className="max-w-3xl mx-auto py-0 bg-white pdfConentAreasCustomize">
        {/* Header */}
        <div className="relative">
          <div className="w-full bg-gray-800 relative h-28 overflow-hidden">
            <div className="relative z-10 flex justify-between items-start">
              {/* Logo Section */}
              <div
                className="relative h-[35rem] w-[35rem] transform"
                style={{
                  backgroundColor: invoiceSetting?.second_code || "black",
                  borderColor: invoiceSetting?.first_code || "orange",
                  clipPath: "polygon(100% 0px, 90% -2%, 0% 125%, 0px 0px)",
                  borderWidth: "1px",
                }}
              >
                <div className="text-white text-2xl font-bold tracking-wider p-2 flex items-center gap-2">
                  <img
                    src={invoiceSetting?.shop_logo || "/placeholder.svg"}
                    alt="Shop Logo"
                    className="w-[70px] sm:w-[90px] md:w-[120px] object-contain mt-1"
                  />
                  <p className="text-white text-sm tracking-widest mt-1 p-2 ">{invoiceSetting?.slogan || ""}</p>
                </div>
              </div>

              <div
                className=" absolute left-52 h-3 -rotate-[58deg] w-80 z-10"
                style={{
                  backgroundColor: invoiceSetting?.first_code || "orange",
                }}
              ></div>
              <div
                className="absolute top-[6.3rem] h-3 w-[19rem]"
                style={{
                  backgroundColor: invoiceSetting?.first_code || "orange",
                }}
              ></div>

              {/* Invoice Section */}
              <div className="text-right pt-4 pr-4 pb-2">
                <h2
                  className=" text-3xl"
                  style={{
                    color: invoiceSetting?.first_code || "orange",
                  }}
                >
                  PURCHASE
                </h2>
                <p className="text-white text-sm mt-1">ID NO : {invoice.invoice_id}</p>
              </div>
            </div>

            {/* Bottom Border */}
            <div className="absolute bottom-0 left-0 w-full h-4 bg-white" />
          </div>
          <div className="absolute bottom-0 right-0 w-1/3 h-full bg-orange-300 -z-10 transform skew-x-12 origin-bottom-right" />
        </div>

        {/* Invoice Details */}
        <div className="grid grid-cols-3 gap-4 mt-4">
          {/* Invoice To Section */}
          <div className="flex flex-col justify-start space-y-2">
            <h3
              className={`border-t-4 border-l-4 text-white px-4 py-1 inline-block ${
                invoiceSetting?.second_code ? "" : "bg-gray-900"
              }`}
              style={{
                backgroundColor: invoiceSetting?.second_code || undefined,
                borderColor: invoiceSetting?.first_code ? invoiceSetting.first_code : "orange",
              }}
            >
              Vendor Details:
            </h3>
            <div className="mt-2">
              <p className="font-semibold">{invoice.vendor_name}</p>
              <p className="text-gray-600">
                Phone: {invoice.country_code || ""}
                {invoice.vendor_phone}
              </p>
              <p className="text-gray-600">Vendor ID: {invoice.vendor_id}</p>
              <p className="text-gray-600">Purchase Date: {formattedDateTime}</p>
            </div>
          </div>

          {/* QR Code Section */}
          <div className="flex justify-center items-center">
            <div className="w-[45px] sm:w-[65px] md:w-[100px]">
              <QRCode
                className="w-full object-contain"
                value={BASE_URL + "/purchase-invoice/" + invoice?.invoice_id}
                size={100}
              />
            </div>
          </div>

          {/* Invoice From Section */}
          <div className="flex flex-col justify-start items-end">
            <h3
              className={`border-t-4 border-l-4 text-white px-4 py-1 inline-block ${
                invoiceSetting?.second_code ? "" : "bg-gray-900"
              }`}
              style={{
                backgroundColor: invoiceSetting?.second_code || undefined,
                borderColor: invoiceSetting?.first_code ? invoiceSetting.first_code : "orange",
              }}
            >
              Company Details:
            </h3>
            <div className="mt-2 text-right">
              <p className="font-semibold">{invoiceSetting?.shop_name}</p>
              <p className="text-gray-600">
                Phone: {invoiceSetting?.mobile_number ? invoiceSetting?.mobile_number : invoice?.user_info?.phone}
              </p>
              <p className="text-gray-600">Address: {invoice?.user_info?.address}</p>
              <p className="text-gray-600">Web: {invoiceSetting?.web_address || ""}</p>
            </div>
          </div>
        </div>

        {/* Products Table */}
        <div className="mt-2 overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr
                style={{
                  backgroundColor: invoiceSetting?.first_code || "orange",
                }}
              >
                <th className="border-r-4 border-white text-center py-2 text-white">#</th>
                <th className="border-r-4 border-white text-center py-2 text-white">Name</th>
                <th className="border-r-4 border-white text-center py-2 text-white">DETAILS</th>
                <th className="border-r-4 border-white text-center py-2 text-white">QTY</th>
                <th className="border-r-4 border-white text-center py-2 text-white">PRICE</th>
                <th className="border-r-4 border-white text-center py-2 text-white">TOTAL</th>
              </tr>
            </thead>

            <tbody className="divide-y-1 font-nunito font-semibold">
              {(() => {
                let rowCounter = 0
                let subtotalPrice = 0

                // Purchase Rows
                const purchaseRows = invoice?.purchase_details?.map((item, index) => {
                  totalQty += Number(item.qty)
                  totalItems += 1

                  const hasImei = item.product_imei && item.product_imei.length > 0

                  if (hasImei) {
                    return item.product_imei.map((imei, imeiIndex) => {
                      subtotalPrice += Number(imei.purchase_price || 0)
                      totalPricePrintCustomize += Number(imei.purchase_price || 0)
                      totalItemsPrintCustomize += 1

                      return (
                        <tr key={`${item.id}-${imeiIndex}`} className="text-sm border-b-2 border-gray-200">
                          <td className="py-1 px-4 text-center">{++rowCounter}</td>
                          <td className="py-1 px-4">
                            {item.product_info.name}
                            <br />
                            <span className="text-[10px]">{imei.imei || item.product_info.serial}</span>
                          </td>
                          <td className="py-1 px-4 text-center">
                            {imei.color ? `${imei.color} - ` : ""}
                            {imei.storage ? `${imei.storage} GB` : ""}
                            {imei.battery_life ? ` - ${imei.battery_life}% Battery` : ""}
                          </td>
                          <td className="py-1 px-4 text-center">1</td>
                          <td className="py-1 px-4 text-right">{formatPrice(imei.purchase_price)}</td>
                          <td className="py-1 px-4 text-right">
                            {formatPrice(imei.purchase_price)}
                            {invoiceSetting?.currency_info?.code || " BDT"}
                          </td>
                        </tr>
                      )
                    })
                  } else {
                    const itemSubtotal = item.qty * item.price
                    subtotalPrice += itemSubtotal
                    totalPricePrintCustomize += itemSubtotal

                    return (
                      <tr key={item.id} className="text-sm border-b-2 border-gray-200">
                        <td className="py-1 px-4 text-center">{++rowCounter}</td>
                        <td className="py-1 px-4">
                          {item.product_info.name}
                          <br />
                          <span className="text-[10px]">{item.product_info.serial}</span>
                          <span className="text-[10px]">{item?.product_variant?.name}</span>
                        </td>
                        <td className="py-1 px-4 text-center">{item.product_info.description || "-"}</td>
                        <td className="py-1 px-4 text-center">{item.qty}</td>
                        <td className="py-1 px-4 text-right">{formatPrice(item.price)}</td>
                        <td className="py-1 px-4 text-right">
                          {formatPrice(item.qty * item.price)} {invoiceSetting?.currency_info?.code || " BDT"}
                        </td>
                      </tr>
                    )
                  }
                })

                totalPrice = subtotalPrice

                return purchaseRows
              })()}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="mt-3 flex justify-between gap-8 px-4">
          {/* Left: Paid By Section */}
          <div className="flex-1 relative">
            {invoice?.multiple_payments?.length > 0 ? (
              <div>
                {(() => {
                  const grandTotal = Number.parseFloat(
                    (Number(totalPrice) + Number(invoice?.vat || 0) + Number(invoice?.tax || 0)).toFixed(2),
                  )
                  const paidAmount = Number(invoice.paid_amount && invoice.paid_amount !== 0 ? invoice.paid_amount : 0)
                  const dueAmount = grandTotal - paidAmount

                  const isFullyPaid = dueAmount === 0
                  const isFullyDue = paidAmount === 0
                  const isPartiallyPaid = paidAmount > 0

                  return (
                    <span
                      style={{
                        letterSpacing: "0.08em",
                        transform: "rotate(-45deg)",
                        display: "inline-block",
                        position: "absolute",
                        opacity: 1,
                        fontSize: "14px",
                        color: "gray",
                        top: "50%",
                        left: "50%",
                        transformOrigin: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isFullyDue ? (
                        "The amount is fully due"
                      ) : (
                        <>
                          Paid by{" "}
                          {invoice?.multiple_payments
                            ?.map((payment) => payment.payment_type.type_name)
                            .join(", ")
                            .replace(/, ([^,]*)$/, " and $1")}{" "}
                          {isFullyPaid ? "" : "Partially"}
                        </>
                      )}
                    </span>
                  )
                })()}
              </div>
            ) : (
              <span>No payment information available</span>
            )}
          </div>

          {/* Right: Subtotal Section */}
          <div className="flex-1 text-right">
            <p className="flex justify-between">
              <span className="font-semibold font-nunito">Subtotal:</span>
              <span className="font-semibold font-nunito">
                {formatPrice(totalPricePrintCustomize || totalPrice)} {invoiceSetting?.currency_info?.code || " BDT"}
              </span>
            </p>
            {Number(invoice.tax) > 0 && (
              <p className="flex justify-between">
                <span className="font-semibold font-nunito">Service Charge:</span>
                <span className="font-semibold font-nunito">
                  {formatPrice(invoice.tax || 0)} {invoiceSetting?.currency_info?.code || " BDT"}
                </span>
              </p>
            )}
            {Number(invoice.vat) > 0 && (
              <p className="flex justify-between">
                <span className="font-semibold font-nunito">VAT:</span>
                <span className="font-semibold font-nunito">
                  {formatPrice(invoice.vat || 0)} {invoiceSetting?.currency_info?.code || " BDT"}
                </span>
              </p>
            )}
            {Number(invoice.discount) > 0 && (
              <p className="flex justify-between">
                <span className="font-semibold font-nunito">Discount:</span>
                <span className="font-semibold font-nunito">
                  {formatPrice(invoice.discount || 0)} {invoiceSetting?.currency_info?.code || " BDT"}
                </span>
              </p>
            )}
            <div
              style={{
                borderTop: "0.5px solid #D3D3D3",
                margin: "10px 0",
              }}
            ></div>
            <p className="flex justify-between">
              <span className="font-semibold font-nunito">Grand Total:</span>
              <span className="font-semibold font-nunito">
                {formatPrice(invoiceCalculate(invoice, "purchase").grandTotal || 0)}{" "}
                {invoiceSetting?.currency_info?.code || " BDT"}
              </span>
            </p>
            <p className="flex justify-between">
              <span className="font-semibold font-nunito">Paid Amount:</span>
              <span className="font-semibold font-nunito">
                {formatPrice(paidAmount || 0)} {invoiceSetting?.currency_info?.code || " BDT"}
              </span>
            </p>
            <div
              style={{
                borderTop: "0.5px solid #D3D3D3",
                margin: "10px 0",
              }}
            ></div>
            <p className="flex justify-between">
              <span className="font-semibold font-nunito">Due Amount:</span>
              <span className="font-semibold font-nunito">
                {formatPrice(invoiceCalculate(invoice, "purchase").dueAmount || 0)}{" "}
                {invoiceSetting?.currency_info?.code || " BDT"}
              </span>
            </p>
            <div
              className="mt-1 text-white px-4 py-2 inline-block"
              style={{
                backgroundColor: invoiceSetting?.first_code || "orange",
              }}
            >
              <span className="font-bold">
                TOTAL: {formatPrice(invoiceCalculate(invoice, "purchase").grandTotal || 0)}{" "}
                {invoiceSetting?.currency_info?.code || " BDT"}
              </span>
            </div>
          </div>
        </div>

        {/* Terms and Signature */}
        {/* <div className="flex justify-between space-x-5 text-[10px] lg:text-sm mt-8">
          <div className="w-1/2">
            <h3 className="text-[10px] font-semibold text-gray-800 mb-2">Terms and Conditions</h3>
            <ul className="list-disc list-inside text-gray-700 text-[10px]">
              {invoiceSetting?.purchase_condition ? (
                <li>{invoiceSetting.purchase_condition}</li>
              ) : (
                <>
                  <li>All items purchased are final sale.</li>
                  <li>Warranty terms as per manufacturer policy.</li>
                  <li>Payment terms as agreed upon in contract.</li>
                </>
              )}
            </ul>
          </div>
          <div className="flex flex-col justify-start items-start">
            <div className="border-t border-gray-400 mt-16">
              <p className="font-bold">Vendor Signature</p>
            </div>

            <div className="border-t border-gray-400 mt-20">
              <p className="font-bold">Authorized Signature</p>
            </div>
            <div className="flex justify-start mt-2">
              <QRCode
                className="w-[50px] object-contain"
                value={
                  invoice?.user_info?.web_address ||
                  invoice?.user_info?.invoice_settings?.web_address ||
                  "No Web Address set to the QR code"
                }
                size={50}
              />
            </div>
          </div>
        </div> */}

        {/* In Words */}
        <p className="text-gray-900 mt-[9px] font-nunito text-[14px] font-semibold leading-normal text-center">
          In Words: {numberToWords(formatPrice(invoiceCalculate(invoice, "purchase").grandTotal))} taka only
        </p>

        {/* Bottom Stripe */}
        <div className="bottom-0 left-0 right-0 p-4">
          <div className="relative h-16 mt-8">
            <div className="absolute bottom-0 left-0 w-full h-full bg-white"></div>
            <div
              className="absolute bottom-0 left-0 w-full h-4"
              style={{
                backgroundColor: invoiceSetting?.first_code || "orange",
              }}
            ></div>
            <div
              className="absolute bottom-0 right-0 w-1/4 h-12 clip-custom"
              style={{
                backgroundColor: invoiceSetting?.second_code || "black",
                clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
              }}
            ></div>
          </div>
        </div>

        {/* Footer Text */}
        {/* <div className="text-center font-nunito mt-4">
          <h2 className="text-orange-500 text-xl font-semibold">Thanks for your business</h2>
          <p className="text-black mt-3 text-xs mb-2">A Product of SQUAD INNOVATORS</p>
        </div> */}
      </div>
    </div>
  )
}

export default PdfHtmlContentPurCustomize
